import { useCartContext } from "app/providers/CartProvider";
import { useOrderContext } from "app/providers/OrderProvider";
import PaymentHeader, { PaymentHeaderTypes } from "entities/payment-header";
import {
  OrderType,
  usePaymentContext,
} from "pages/payment/providers/PaymentProvider";
import { useEffect, useState } from "react";
import Card from "shared/ui/card";
import {
  PaymentType,
  paymentTypesBankTransfer,
  paymentTypesLater,
  paymentTypesRemaining,
} from "shared/utils/payment";
import CheckoutPaymentFooter from "widgets/checkout/payment-footer";
import CheckoutSidebarProducts from "widgets/checkout/sidebar-products";
import StandardProductPayment from "widgets/checkout/standard-product-payment";
import PaymentSidebarProducts from "widgets/payment-sidebar-products";
import PaymentFooter from "widgets/payment/payment-footer";
import PaymentMethods, { PaymentMethod } from "widgets/shared/payment-methods";

const CheckoutPayment = () => {
  const { getCart, isSampleSale, containsZakelijkProducts } = useCartContext();
  const cart = getCart();
  const { type, order } = useOrderContext();
  const {
    paymentAction,
    setPaymentAction,
    getPaymentTypeList,
    getPaymentListWithAssembly,
  } = usePaymentContext();

  const [paymentTypes, setPaymentTypes] = useState<PaymentType[]>([]);

  useEffect(() => {
    if (paymentTypes.length) return;

    if ((type && type === "d") || (cart && cart.products.length)) {
      setDoorPaymentTypes();
    } else {
      setStandardProductPaymentTypes();
    }
  }, [type]);

  const setDoorPaymentTypes = async () => {
    let types: PaymentType[];
    if (cart && cart.sampleSale) {
      types = getPaymentTypeList([
        ...paymentTypesRemaining,
        ...(cart.totalPrice >= 250 ? paymentTypesLater : []),
      ]);
    } else if (containsZakelijkProducts) {
      types = getPaymentListWithAssembly([
        ...paymentTypesRemaining,
        ...paymentTypesBankTransfer,
      ]);
    } else {
      types = getPaymentListWithAssembly([
        ...paymentTypesRemaining,
        ...paymentTypesLater,
      ]);
    }
    setPaymentTypes(types);
  };

  const setStandardProductPaymentTypes = async () => {
    const types = await getPaymentTypeList([
      ...paymentTypesRemaining,
      ...(cart.totalPrice >= 250 ? paymentTypesLater : []),
    ]);
    setPaymentTypes(types);
  };

  const isZakelijk = order?.isZakelijkOrder;
  return (
    <>
      <Card
        className="gg-border-b gg-border-t gg-px-4 gg-py-14 sm:gg-px-14 2xl:gg-px-32"
        shadow={false}
      >
        <div className="gg-grid gg-grid-cols-12">
          <div
            className={`gg-col-span-12 gg-mb-16 sm:gg-col-span-11 lg:gg-col-span-9 xl:gg-col-span-6 xl:gg-mb-0 xl:gg-pr-12`}
          >
            {type === "d" || cart.products.length ? (
              <>
                <PaymentHeader
                  type={PaymentHeaderTypes.ALL_PAYMENTS}
                  className="gg-mb-10"
                  isZakelijk={isZakelijk}
                />
                <PaymentMethods
                  method={PaymentMethod.DEFERRED_PAYMENT}
                  types={paymentTypes}
                  paymentAction={paymentAction}
                  setPaymentAction={setPaymentAction}
                  orderType={OrderType.DOOR}
                  isSampleSale={isSampleSale}
                />
              </>
            ) : (
              <>
                <PaymentHeader
                  type={PaymentHeaderTypes.STANDARD_PRODUCT_PAYMENT}
                  className="gg-mb-10"
                />

                <StandardProductPayment className="gg-col-span-12 gg-mb-14" />
              </>
            )}
          </div>

          <div className="gg-col-span-12 xl:gg-col-span-6">
            {type === OrderType.DOOR ? (
              <PaymentSidebarProducts isSelfAssembly={cart.isSelfAssembly} />
            ) : (
              <CheckoutSidebarProducts />
            )}
          </div>
        </div>
      </Card>

      {type === OrderType.DOOR || (cart && cart.products.length) ? (
        <PaymentFooter hideVoucher={isSampleSale} />
      ) : (
        <CheckoutPaymentFooter />
      )}
    </>
  );
};
export default CheckoutPayment;
